/**
 * Router basename derived from Vite's `base` (`VITE_BASE`, default `/`):
 * `/` -> `''` (app at the domain root), `/admin/` -> `/admin`.
 */
export const ROUTER_BASENAME = import.meta.env.BASE_URL.replace(/\/+$/, '');

/** Browser-level URL (for `window.open`, plain anchors) of an in-app absolute path such as `/users/5`. */
export function appHref(path: string): string {
  return `${ROUTER_BASENAME}${path}`;
}
